import React from 'react';
import { useTranslation } from 'react-i18next';
import IconMC from '../../../components/IconMC';

const MiaInternalMessageMC = ({
  message
}) => {
  const { t } = useTranslation('InboxMC');

  const colors = () => {
    if (message.isBuyIntention) {
      return {
        bg: 'tw-bg-seagull-50',
        border: 'tw-border-seagull-300',
        icon: 'shopping-bag-modern-outline',
        iconBg: 'tw-bg-seagull-500',
        textColor: 'tw-text-seagull-700',
        messageKey: "message.mia.buy_intention"
      };
    }

    if (message.isHumanHelp) {
      return {
        bg: 'tw-bg-violet-50',
        border: 'tw-border-violet-300',
        icon: 'hand',
        iconBg: 'tw-bg-violet-500',
        textColor: 'tw-text-violet-700',
        messageKey: "message.mia.human_help_message"
      };
    }

    if (message.isGeneratedOrder) {
      return {
        bg: 'tw-bg-green-50',
        border: 'tw-border-green-300',
        icon: 'shopping-cart-outline',
        iconBg: 'tw-bg-green-500',
        textColor: 'tw-text-green-700',
        messageKey: "conversation.generated_order.label"
      };
    }

    if (message.isPaymentLink) {
      return {
        bg: 'tw-bg-green-50',
        border: 'tw-border-green-300',
        icon: 'link-outline',
        iconBg: 'tw-bg-green-500',
        textColor: 'tw-text-green-700',
        messageKey: "message.mia.payment_link",
        secondaryMessageKey: "message.mia.payment_link_turn"
      };
    }

    if (message.isOrderError) {
      return {
        bg: 'tw-bg-gray-50',
        border: 'tw-border-gray-300',
        icon: 'shopping-cart-fill',
        iconBg: 'tw-bg-gray-500',
        textColor: 'tw-text-gray-700',
        messageKey: "message.mia.order_error",
        secondaryMessageKey: "message.mia.order_error_detail"
      };
    }

    return {};
  };

  const {
    bg, border, icon, iconBg, textColor, messageKey, secondaryMessageKey
  } = colors();

  return (
    <div className={`tw-flex tw-flex-col tw-p-4 tw-gap-2 tw-rounded-lg ${bg}`}>
      <div className={`tw-flex tw-items-center tw-py-1 tw-px-2 tw-gap-1 tw-bg-white tw-border tw-rounded-lg ${border}`}>
        <IconMC name="alert-circle-outline" className="tw-text-gray-500" size="base" />
        <span className="tw-font-medium tw-text-gray-500 tw-text-3xs">{t('message.mia.internal_message')}</span>
      </div>

      <div className="tw-flex tw-gap-2 tw-items-center">
        <div className={`tw-flex tw-items-center tw-justify-center tw-w-[40px] tw-h-[40px] tw-rounded-full ${iconBg}`}>
          <IconMC
            name={icon}
            className="tw-text-white"
          />
        </div>
        <div className={`tw-flex tw-flex-col ${textColor}`}>
          <span className="tw-font-bold tw-text-xs">{t(messageKey)}</span>
          <span className="tw-text-xs">{t(secondaryMessageKey || 'message.mia.internal_message_turn')}</span>
        </div>
      </div>
    </div>
  );
};

export default MiaInternalMessageMC;
